import { AxiosService } from './axios.service'
import { StorageService } from './storage.service'

/**
 * Defines the API methods for payment methods/installments
 */
export class PaymentService {
	/**
	 * Get the available payment methods, fees and installment options for the current cart
	 * @param {{ oneClickBuy?: boolean }} options oneClickBuy: o cliente paga com o Muvicard 1-clique. O Hub
	 * (e o legado) decidem a 1a compra pelo historico do cartao igual ao fechamento do pedido: compra 1-clique
	 * nao e primeira compra, entao a grade NAO pode mostrar o desconto de 1a compra (D10).
	 * @return {Promise<any>} { methods, installments, conversionRateToken, expiresAtUtc, fxRates }
	 */
	static getMethods({ oneClickBuy = false } = {}) {
		const cart = StorageService.cart.get()
		const params = { cartId: cart && cart.id }
		if (oneClickBuy) params.oneClickBuy = true

		return AxiosService.getMuviHub('payments/methods', { params }).then(
			({ data }) => data.data
		)
	}
}
